@if (errorLoading() || isLoading()) {
	<div
		class="componentsLoading"
		[class.atTopLevel]="topLevel()"
		[class.fullWidthLoadingCon]="fullWidthLoadingCon()"
		[class.isTwoScreen]="isTwoScreen()"
		[class.showBackDrop]="showBackDrop()"
		[class.backDropVarientTwo]="backdropVariantTwo()"
		[class.errorLoading]="errorLoading()"
		[attr.aria-label]="isLoading() ? 'loading' : ''"
		[attr.role]="errorLoading() ? 'alert' : ''"
	>
		<div class="innerLoadingCon">
			<h2 [class.mat-h2]="size() === 'normal'" [class.mat-h1]="size() === 'big'">
				{{ errorLoading() ? errorMessage() : loadingMessage() }}
			</h2>

			@if (loadingDescriptionMessage()) {
				<div class="loadingDescription">
					{{ loadingDescriptionMessage() }}
				</div>
			}

			<ng-content select="[actions]" />

			<div class="loadingDiv">
				@if (isLoading()) {
					<i class="fad fa-spinner-third fa-spin" [class.fa-5x]="size() === 'normal'" [class.fa-9x]="size() === 'big'"> </i>
					<i class="innerIcon {{ loadingIcon() }}" [class.big]="size() === 'big'"></i>
				}
			</div>

			@if (errorLoading()) {
				<i class="innerIcon fad fa-telescope fa-5x"></i>
			}
		</div>
	</div>
}
